/**
 * Created by brianschroer on 12/16/15.
 */
(function () {
    "use strict";

    // @ngInject
    function CalendlyDisconnectModalControllerCtor($modalInstance, $scope, $injector, UsersManager, AnalyticsService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CalendlyDisconnectModalController';
        AnalyticsService.trackPageView(this, 'CalendlyDisconnectModalView');

        this.$modalInstance = $modalInstance;

        this.UsersManager = UsersManager;
        this.user = this.UsersManager.getCurrUser();
    }

    Controllers.CalendlyDisconnectModalController = Class(Controllers.BaseController, {

        constructor: CalendlyDisconnectModalControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        },

        cancel: function cancel() {
            this.$modalInstance.dismiss();
        },

        disconnect: function disconnect() {
            this.showCalendlyLoader = true;
            this.UsersManager.deleteCalendlysubscription(this.user)
                .then(function success() {
                    this.UsersManager.forceFetchCurrUser();
                    this.close();
                }.bind(this), function fail() {
                    this.cancel();
                }.bind(this))
                .finally(function () {
                    this.showCalendlyLoader = false;
                }.bind(this));
        }
    });
}());
